module.exports = __webpack_public_path__ + "img/readfic-success.d95173b8.png";